import 'intl';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'

import App from './App';
import { switchLang } from './redux/actions';

import registerServiceWorker from './registerServiceWorker';
// import './index.css';

import { IntlProvider } from 'react-intl';
import { getIntl } from './utils/intl';
import store from './redux/store';

function getParameterByName(name) {
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

const lang = getParameterByName('lang');
if (['fi', 'en'].indexOf(lang) > -1 && lang !== store.getState().lang) {
  store.dispatch(switchLang());
}

const locale = store.getState().lang;
const intl = getIntl(locale);


ReactDOM.render((
  <Provider store={store}>
    <IntlProvider {...intl}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </IntlProvider>
  </Provider>
), document.getElementById('app-container'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js